
import { Question } from '../types';

export const taj101NunMimQuestions: Question[] = [
  {
    id: 'taj061',
    text: 'What happens when nūn or mīm are mushaddadah (have a shadda)?',
    type: 'single',
    options: [
      { id: 'a', text: 'They are read with ghunnah (nasal sound)', isCorrect: true },
      { id: 'b', text: 'They are read with ikhfāʾ', isCorrect: false },
      { id: 'c', text: 'They are read with iṭh-hār', isCorrect: false },
      { id: 'd', text: 'They are read with iqlāb', isCorrect: false }
    ],
    explanation: 'If the nūn (ن) or the mīm (م) are mushaddadah, they will be read with ghunnah (a nasal sound), e.g., إِنَّ, عَمَّ.',
    topic: 'taj101'
  },
  {
    id: 'taj062',
    text: 'How many rules does the mīm sākinah have?',
    type: 'single',
    options: [
      { id: 'a', text: 'Three rules', isCorrect: true },
      { id: 'b', text: 'Four rules', isCorrect: false },
      { id: 'c', text: 'Two rules', isCorrect: false },
      { id: 'd', text: 'Five rules', isCorrect: false }
    ],
    explanation: 'The mīm sākinah has three rules: ikhfāʾ, idghām, and iṭh-hār.',
    topic: 'taj101'
  },
  {
    id: 'taj063',
    text: 'When does ikhfāʾ occur for mīm sākinah?',
    type: 'single',
    options: [
      { id: 'a', text: 'When followed by a bāʾ (ب)', isCorrect: true },
      { id: 'b', text: 'When followed by a mīm (م)', isCorrect: false },
      { id: 'c', text: 'When followed by a nūn (ن)', isCorrect: false },
      { id: 'd', text: 'When followed by any other letter', isCorrect: false }
    ],
    explanation: 'Ikhfāʾ for mīm sākinah occurs when it is followed by a bāʾ (ب). The mīm will be concealed and read with ghunnah. This is called ikhfāʾ shafawī.',
    topic: 'taj101'
  },
  {
    id: 'taj064',
    text: 'Why is the ikhfāʾ of mīm sākinah called "shafawī"?',
    type: 'single',
    options: [
      { id: 'a', text: 'Because both mīm and bāʾ are pronounced from the lips', isCorrect: true },
      { id: 'b', text: 'Because it only occurs at the end of words', isCorrect: false },
      { id: 'c', text: 'Because it\'s related to the Quran\'s oral tradition', isCorrect: false },
      { id: 'd', text: 'Because it was named after a scholar', isCorrect: false }
    ],
    explanation: '"Shafah" means lips. It is called "shafawī" because the mīm is pronounced from the lips.',
    topic: 'taj101'
  },
  {
    id: 'taj065',
    text: 'When does idghām occur for mīm sākinah?',
    type: 'single',
    options: [
      { id: 'a', text: 'When followed by another mīm (م)', isCorrect: true },
      { id: 'b', text: 'When followed by a bāʾ (ب)', isCorrect: false },
      { id: 'c', text: 'When followed by a nūn (ن)', isCorrect: false },
      { id: 'd', text: 'When followed by any other letter', isCorrect: false }
    ],
    explanation: 'Idghām for mīm sākinah occurs when it is followed by another mīm (م). The first mīm will be assimilated into the second mīm and read with ghunnah.',
    topic: 'taj101'
  },
  {
    id: 'taj066',
    text: 'When does iṭh-hār occur for mīm sākinah?',
    type: 'single',
    options: [
      { id: 'a', text: 'When followed by any letter besides bāʾ and mīm', isCorrect: true },
      { id: 'b', text: 'When followed by a bāʾ (ب)', isCorrect: false },
      { id: 'c', text: 'When followed by a mīm (م)', isCorrect: false },
      { id: 'd', text: 'Only when followed by a throat letter', isCorrect: false }
    ],
    explanation: 'Iṭh-hār for mīm sākinah occurs when it is followed by any letter besides the bāʾ (ب) (of ikhfāʾ) or the mīm (م) (of idghām). The mīm will be read clearly without any extra ghunnah. This is called iṭh-hār shafawī.',
    topic: 'taj101'
  },
  {
    id: 'taj067',
    text: 'How many rules do nūn sākinah and tanwīn have?',
    type: 'single',
    options: [
      { id: 'a', text: 'Four rules', isCorrect: true },
      { id: 'b', text: 'Three rules', isCorrect: false },
      { id: 'c', text: 'Two rules', isCorrect: false },
      { id: 'd', text: 'Five rules', isCorrect: false }
    ],
    explanation: 'The nūn sākinah and tanwīn have four rules: iṭh-hār, idghām, iqlāb, and ikhfāʾ.',
    topic: 'taj101'
  },
  {
    id: 'taj068',
    text: 'When does iṭh-hār occur for nūn sākinah and tanwīn?',
    type: 'single',
    options: [
      { id: 'a', text: 'When followed by any of the throat letters', isCorrect: true },
      { id: 'b', text: 'When followed by a bāʾ (ب)', isCorrect: false },
      { id: 'c', text: 'When followed by the letters of يَرْمَلُوْنَ', isCorrect: false },
      { id: 'd', text: 'When followed by any other letter', isCorrect: false }
    ],
    explanation: 'Iṭh-hār for nūn sākinah and tanwīn occurs when they are followed by any of the throat letters (ء, هـ, ع, ح, غ, خ). They will be pronounced clearly without any extra ghunnah.',
    topic: 'taj101'
  },
  {
    id: 'taj069',
    text: 'When does idghām occur for nūn sākinah and tanwīn?',
    type: 'single',
    options: [
      { id: 'a', text: 'When followed by any of the letters of يَرْمَلُوْنَ', isCorrect: true },
      { id: 'b', text: 'When followed by a bāʾ (ب)', isCorrect: false },
      { id: 'c', text: 'When followed by the throat letters', isCorrect: false },
      { id: 'd', text: 'When followed by any other letter', isCorrect: false }
    ],
    explanation: 'Idghām for nūn sākinah and tanwīn occurs when they are followed by any of the letters of يَرْمَلُوْنَ. Idghām is of two types: with ghunnah (for ي, ن, م, و) and without ghunnah (for ل, ر).',
    topic: 'taj101'
  },
  {
    id: 'taj070',
    text: 'When does iqlāb occur for nūn sākinah and tanwīn?',
    type: 'single',
    options: [
      { id: 'a', text: 'When followed by a bāʾ (ب)', isCorrect: true },
      { id: 'b', text: 'When followed by a mīm (م)', isCorrect: false },
      { id: 'c', text: 'When followed by the letters of يَرْمَلُوْنَ', isCorrect: false },
      { id: 'd', text: 'When followed by the throat letters', isCorrect: false }
    ],
    explanation: 'Iqlāb for nūn sākinah and tanwīn occurs when they are followed by a bāʾ (ب). The nūn sākinah or tanwīn will be changed into a mīm (م) and read with ghunnah.',
    topic: 'taj101'
  }
];
